export default {
  settingStatementBase: {
    title: '基础设置',
    name: '渠道名称',
    onOff: '开/关',
    operationRecord: '操作记录',
    field: '字段维护',
    shop: '对账店铺维护',
    operator: '操作人',
    tableContent: '开启渠道',
    tableLogName: '老大哥',
    addField: '新增字段',
    fieldName: '字段名称',
    sort: '排序',
    revise: '修改',
    tableFieldName: '账务流水号',
    storeName: '店铺名称',
    storeCode: '店铺编码',
    storeText: '没有您想要设置对账的店铺？',
    storeAddText: '去新增店铺',
    tableShopName: '天猫_九牧官方旗舰店_分销_2000',
  },
};
